<template>
  <div v-if="section_info">
    <v-container fluid>
      <v-card flat tile>
        <student-gradebook-table
          v-if="showTable"
          :scores="scores"
          :average="average + ''"
        >
        </student-gradebook-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>

import StudentGradebookTable from "./StudentGradebookTable.vue";

export default {
  components: { StudentGradebookTable },
  props: {
    section_info: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showTable: false,
    scores: [],
    average: "N/A",
  }),
  watch: {
    section_info: "getGradeBook",
  },
  methods: {
    getGradeBook() {
      if (this.section_info.course_id) {
        this.$sisApi("get", `my-schedule/self-course-gradebook/${this.section_info.section_id}`)
          .then((response) => {
            this.showTable = true;
            this.scores = response.data.filter( s => s.id > 0);
            this.average = response.data.find( s => s.id == 0).avg;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getGradeBook();
  },
};
</script>
